import { render, staticRenderFns } from "./BlockUserModal.vue?vue&type=template&id=f675dd94&scoped=true&"
import script from "./BlockUserModal.vue?vue&type=script&lang=ts&"
export * from "./BlockUserModal.vue?vue&type=script&lang=ts&"
import style0 from "./BlockUserModal.vue?vue&type=style&index=0&id=f675dd94&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f675dd94",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VIcon,VRow})
